import { useId } from 'react';

/** App mark: a navy tile with an almost closed progress ring and a check. */
export function Logo({ size = 40, className }: { size?: number; className?: string }) {
  const id = useId();
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 64 64" aria-hidden="true">
      <defs>
        <linearGradient id={`${id}-bg`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#3553b8" />
          <stop offset="1" stopColor="#14204d" />
        </linearGradient>
        <linearGradient id={`${id}-ring`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#9db1ff" />
          <stop offset="1" stopColor="#5ccbff" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx="18" fill={`url(#${id}-bg)`} />
      <rect x="0.75" y="0.75" width="62.5" height="62.5" rx="17.25" fill="none" stroke="rgba(255,255,255,.18)" strokeWidth="1.5" />
      <circle cx="32" cy="32" r="17" fill="none" stroke="rgba(255,255,255,.16)" strokeWidth="5" />
      <path d="M32 15 A17 17 0 1 1 17.28 23.5" fill="none" stroke={`url(#${id}-ring)`} strokeWidth="5" strokeLinecap="round" />
      <path d="M24.5 32.5l5.2 5.2 10-11" fill="none" stroke="#fff" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
